import styled from 'styled-components';

const Label = styled.span`
  display: flex;
  justify-content: center;
  color: #566976;
`;

export default { Label };
